const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the journey search component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('journeySearch', ['Journeys', function (Journeys) {
  return {
    restrict: 'E',
    scope: {
      onChange: '&',
      selectionLimit: '@'
    },
    replace: true,
    template: require('../../../templates/directives/journeys/journey-search.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      
      self.queries = [];

      // ------------- start ngTag triggered actions ------------
      self.tagInput = {
        addingTag: function ($tag) {
          if (!$tag._id) {
            $tag.text = $tag.title;
            $tag.type = 'text';
          }
          if ($scope.selectionLimit) {
            if (self.queries.length && self.queries.length >= $scope.selectionLimit) {
              self.queries.splice(0, 1);
            }
          }
          return true;
        },
        addedTag: function ($tag, outside) {
          self.updateQuery();
        },
        removedTag: function ($tag) {
          self.updateQuery();
        },
        clear: function (outside) {
          self.queries.splice(0);
          if (!outside) {
            self.updateQuery();
          }
        }
      };
      // ------------- End ngTag triggered actions ------------

      self.updateQuery = function() {
        $scope.onChange({items: self.queries});
      };

      self.getOptions = async function(input) {
        // Just searching by title  for now
        return await Journeys.find({query: {term: input}}).$promise;
      };
    }],

    controllerAs: 'search'
  };
}]);